import { type GraduateServiceDocuments } from "@/components/fragments/forms/document-checkbox-form/types";
import { GraduateServiceCompanies } from "@/gql/generated/graphql.gen";

export const confirmScreenTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen";
export const confirmScreenTitleTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-Title";
export const confirmScreenDescriptionTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-Description";
export const confirmScreenDocumentsTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-Documents";
export const confirmScreenDocumentsTitleTestId =
  "pages/quit/__components__/confirm-screen/ConfirmScreen-DocumentsTitle";
export const confirmScreenDocumentsDescriptionTestId =
  "pages/quit/__components__/confirm-screen/ConfirmScreen-DocumentsDescription";

export const confirmScreenReturnExpiresDateDescriptionTestId =
  "pages/quit/__components__/confirm-screen/ConfirmScreen-returnExpiresDateDescription";
export const confirmScreenReturnExpiresDateTestId =
  "pages/quit/__components__/confirm-screen/ConfirmScreen-returnExpiresDate";
export const confirmScreenNoticeTextTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-noticeText";
export const confirmScreenCheckboxTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-checkbox";
export const confirmScreenSubmitButtonTestId = "pages/quit/__components__/confirm-screen/ConfirmScreen-submitButton";

export const graduateServiceDocuments: GraduateServiceDocuments[] = [
  {
    kind: GraduateServiceCompanies.Dwe,
    image: "/images/document_dwe.png",
    title: "【0-4歳のパパママ必見】ディズニー英語システムの無料サンプル",
    description:
      "※無料サンプル及びプレゼントは、マタニティまたは0～4歳のお子さまをお持ちの方のみとさせていただきます(一家族1回限り/日本国内のみ発送/初めて資料請求いただいた方のみ)。\n" +
      "※既にディズニー英語システムをご購入いただいているお客さまは対象外となります。\n" +
      "※無料サンプル及びプレゼントのアイテム・デザイン・内容・映像等は予告なく変更になる場合がございます。",
  },
  {
    kind: GraduateServiceCompanies.Smilezemi,
    image: "/images/document_smilezemi.png",
    title: "【2ｰ6歳のパパママ必見！】タブレット1台で学ぶ通信教育 スマイルゼミ",
    description:
      "2歳のお子さまも、楽しく一人で学べる工夫と仕組みが満載。\n" +
      "毎日、少しずつ取り組むだけで、お子さまの興味&好奇心を広げ、小学校入学へ向けて、自然と「学ぶ習慣」と「学習の土台」が築けます。\n" +
      "詳しくは資料請求で確認！",
  },
  {
    kind: GraduateServiceCompanies.Zenb,
    image: "/images/document_zenb.png",
    title: "【おうちのぜんぶ】元大手住宅メーカー出身に無料で住宅相談!",
    description:
      "人生最大の決断だから、後悔したくない。\n" +
      "経験豊富なアドバイザーが30年後の暮らしまで見据えて、あなたに最適なメーカー・工務店を中立に厳選。まずは無料相談へ。",
  },
  {
    kind: GraduateServiceCompanies.Tao,
    image: "/images/document_tao.jpg",
    title: "テレビ番組で話題！0歳～6歳の内容が学べる【天神】",
    description:
      "5系統60ジャンル以上収録。乳幼児期のインプットからお受験レベルのアウトプットまで対応の本格タブレット教材",
  },
];
